/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AttritionRiskResultDto } from '../models';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
/**
 * TeamAttritionRiskApi - axios parameter creator
 * @export
 */
export const TeamAttritionRiskApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sekcja \"Ryzyko odejscia\" zakladki Ryzyko i sukcesja. Zwraca osoby z ryzykiem wysokim i srednim, wysokie najpierw. Stronicowana, bo w perspektywie ADMIN zakres obejmuje cala firme, a panel pokazuje tylko poczatek listy. 
         * @summary People at elevated risk of leaving within the caller\'s area (JAIN-503)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAttritionRisk: async (pageSize: number, page: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('readAttritionRisk', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('readAttritionRisk', 'page', page)
            const localVarPath = `/api/v2/team/development/attrition-risk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamAttritionRiskApi - functional programming interface
 * @export
 */
export const TeamAttritionRiskApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamAttritionRiskApiAxiosParamCreator(configuration)
    return {
        /**
         * Sekcja \"Ryzyko odejscia\" zakladki Ryzyko i sukcesja. Zwraca osoby z ryzykiem wysokim i srednim, wysokie najpierw. Stronicowana, bo w perspektywie ADMIN zakres obejmuje cala firme, a panel pokazuje tylko poczatek listy. 
         * @summary People at elevated risk of leaving within the caller\'s area (JAIN-503)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readAttritionRisk(pageSize: number, page: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttritionRiskResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readAttritionRisk(pageSize, page, accessType, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamAttritionRiskApi.readAttritionRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamAttritionRiskApi - factory interface
 * @export
 */
export const TeamAttritionRiskApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamAttritionRiskApiFp(configuration)
    return {
        /**
         * Sekcja \"Ryzyko odejscia\" zakladki Ryzyko i sukcesja. Zwraca osoby z ryzykiem wysokim i srednim, wysokie najpierw. Stronicowana, bo w perspektywie ADMIN zakres obejmuje cala firme, a panel pokazuje tylko poczatek listy. 
         * @summary People at elevated risk of leaving within the caller\'s area (JAIN-503)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAttritionRisk(pageSize: number, page: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<AttritionRiskResultDto> {
            return localVarFp.readAttritionRisk(pageSize, page, accessType, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamAttritionRiskApi - interface
 * @export
 * @interface TeamAttritionRiskApi
 */
export interface TeamAttritionRiskApiInterface {
    /**
     * Sekcja \"Ryzyko odejscia\" zakladki Ryzyko i sukcesja. Zwraca osoby z ryzykiem wysokim i srednim, wysokie najpierw. Stronicowana, bo w perspektywie ADMIN zakres obejmuje cala firme, a panel pokazuje tylko poczatek listy. 
     * @summary People at elevated risk of leaving within the caller\'s area (JAIN-503)
     * @param {number} pageSize 
     * @param {number} page 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamAttritionRiskApiInterface
     */
    readAttritionRisk(pageSize: number, page: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<AttritionRiskResultDto>;

}

/**
 * TeamAttritionRiskApi - object-oriented interface
 * @export
 * @class TeamAttritionRiskApi
 * @extends {BaseAPI}
 */
export class TeamAttritionRiskApi extends BaseAPI implements TeamAttritionRiskApiInterface {
    /**
     * Sekcja \"Ryzyko odejscia\" zakladki Ryzyko i sukcesja. Zwraca osoby z ryzykiem wysokim i srednim, wysokie najpierw. Stronicowana, bo w perspektywie ADMIN zakres obejmuje cala firme, a panel pokazuje tylko poczatek listy. 
     * @summary People at elevated risk of leaving within the caller\'s area (JAIN-503)
     * @param {number} pageSize 
     * @param {number} page 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamAttritionRiskApi
     */
    public readAttritionRisk(pageSize: number, page: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return TeamAttritionRiskApiFp(this.configuration).readAttritionRisk(pageSize, page, accessType, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

